var Acl = /*#__PURE__*/function () {
  function Acl() {
    this.droits = new Map();
  }
  var _proto = Acl.prototype;
  _proto.registerDroit = function registerDroit(droit) {
    this.droits.set(droit.sujet, droit);
  };
  _proto.hasDroit = function hasDroit() {
    return !![].concat(this.droits.values()).length;
  };
  _proto.isAllow = function isAllow(sujet, action) {
    if (!this.hasDroit()) return true;
    if (!this.droits.has(sujet)) return false;
    return this.droits.get(sujet).isAllow(action);
  };
  return Acl;
}();
export default Acl;